import React, { useState, useEffect, useContext } from "react";
import RequestForm from "../../../components/forms/request/RequestForm";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PageHeader, Button, Popconfirm } from "antd";
import RequestContext from "../../../context/request/RequestContext";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import useQuery from "../../../hooks/useQuery";
import {
  successNotification,
  infoNotification,
  errorNotification,
} from "../../../components/openNotification";
import { enableEditQueryString } from "../../../config/queryStrings";
import { requestsRoute } from "../../../config/routes";
import LargeContainer from "../../../components/layouts/containers/LargeContainer";
import FormContainer from "../../../components/layouts/containers/FormContainer";

function RequestDetailsPage() {
  const [enableEdit, setEnableEdit] = useState(false);
  const { t } = useTranslation();
  const history = useHistory();
  const { request, updateRequest, deleteRequest, deleteLoading } = useContext(
    RequestContext
  );

  const query = useQuery();

  useEffect(() => {
    const enable = query.get(enableEditQueryString) === "true";
    setEnableEdit(enable);
  }, []);

  const submitForm = async (values) => {
    const updatedRequest = await updateRequest(request.id, values);
    if (!updatedRequest.errors) {
      successNotification(
        "Okay!",
        t("RequestDetailsPage.successfullyUpdatedMessage")
      );
      setEnableEdit(false);
    } else {
      errorNotification(
        t("problem", t("RequestDetailsPage.errorUpdatingMessage"))
      );
    }
  };

  const deleteTheRequest = async () => {
    await deleteRequest();
    infoNotification("Okay!", t("RequestDetailsPage.deletedMessage"));
    history.push(requestsRoute);
  };

  return (
    <>
      <PageHeader
        onBack={() => history.goBack()}
        title={t("RequestDetailsPage.detailsPageTitle")}
        subTitle={t("RequestDetailsPage.detailsPageDescription")}
        extra={[
          <Button
            key="1"
            icon={<EditOutlined />}
            onClick={() => setEnableEdit(true)}
            disabled={enableEdit}
          >
            {t("action.edit")}
          </Button>,
          <Popconfirm
            key="2"
            title={t("askConfirmationMessage")}
            placement="topRight"
            onConfirm={() => deleteTheRequest()}
            okText={t("ok")}
            cancelText={t("cancel")}
          >
            <Button
              icon={<DeleteOutlined />}
              danger
              disabled={!enableEdit || deleteLoading}
            >
              {t("action.delete")}
            </Button>
          </Popconfirm>,
        ]}
      />
      {request && (
        <>
          <LargeContainer hoverable={true}>
            <FormContainer title={t("RequestDetailsPage.requestFormTitle")}>
              <RequestForm
                request={request}
                onSubmit={submitForm}
                disableAll={!enableEdit || deleteLoading}
              />
            </FormContainer>
          </LargeContainer>
        </>
      )}
    </>
  );
}

export default RequestDetailsPage;
